import {useCallback,useEffect,useMemo,useState} from 'react'
import {workspaceApi} from './workspaceApi.js'
import {createLatestWorkspaceRead} from './latestWorkspaceRead.js'
export default function useWorkspace(query={}) {
  const [data,setData]=useState(null),[catalog,setCatalog]=useState(null),[error,setError]=useState(''),[loading,setLoading]=useState(true)
  const queryKey=JSON.stringify(query)
  const reader=useMemo(()=>createLatestWorkspaceRead({
    read:(_value,signal)=>Promise.all([workspaceApi.jobs(JSON.parse(queryKey),{signal}),workspaceApi.catalog({signal})]),
    onStart:()=>{setLoading(true);setError('')},
    onValue:([result,config])=>{setData(result);setCatalog(config)},
    onError:e=>setError(e.message||'The workspace could not be read.'),
    onFinish:()=>setLoading(false),
  }),[queryKey])
  const reload=useCallback(()=>reader.load(JSON.parse(queryKey)),[reader,queryKey])
  useEffect(()=>{reader.activate();setData(null);setCatalog(null);reload();return()=>reader.dispose()},[reload,reader])
  return {data,catalog,error,loading,reload}
}
